import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';

const backendOpts = {
    loadPath: `/static/locales/{{lng}}/{{ns}}.json`,
};
i18n.use(XHR).init({
    lng: window.localStorage.getItem('language') || 'en',
    fallbackLng: 'en',
    load: 'languageOnly',
    ns: ['common'],
    defaultNS: 'common',
    backend: backendOpts,
    debug: false,
    // Question editor preview embeds LMS widgets that call useTranslation('assessment').
    // With default useSuspense: true, loading that namespace suspends during state updates
    // (e.g. after fetch) and React 18 throws "suspended while responding to synchronous input".
    react: {
        useSuspense: false,
    },
});

export default i18n;
